import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { ApiDataResponse, BaseApiDataResponse } from '../Models/ApiData';
import {
    Client,
    ClientDetailsApiDataResponse,
    ClientListOrder,
    ClientListResponse,
    ClientSummaryListResponse,
} from '../Models/Clients/Client';
import { BaseDataService } from './Base/BaseDataService';

export const ClientEndpoints = {
    CLIENTS_SUMMARY: '/api/v1/back/clients/summary',
    CLIENTS: '/api/v1/back/clients',
    CLIENT: (clientId: string) => `/api/v1/back/clients/${clientId}`,
    UPDATE_CLIENT: (clientId: string) => `/api/v1/back/clients/${clientId}`,
    CREATE_CLIENT: '/api/v1/back/clients',
    EXPORT_CLIENT_LIST: '/api/v1/back/clients/export',
};

export interface IClientDataService {
    listClient: (
        params: {
            search?: string;
            order?: ClientListOrder;
            showOnlyActive?: boolean;
        },
        cts: XHRRequestCanceler
    ) => Promise<ClientListResponse>;

    listSummaryClient: (
        params: { search?: string; showOnlyActive?: boolean },
        cts: XHRRequestCanceler
    ) => Promise<ClientSummaryListResponse>;

    getClient: (cts: XHRRequestCanceler, clientId: string) => Promise<ClientDetailsApiDataResponse>;

    updateClient: (
        clientId: string,
        client: Client,
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;

    createClient: (client: Client, cts: XHRRequestCanceler) => Promise<ApiDataResponse<string>>;
}

class ClientDataService extends BaseDataService implements IClientDataService {
    listSummaryClient = (
        params: { search?: string; showOnlyActive?: boolean },
        cts: XHRRequestCanceler
    ): Promise<ClientSummaryListResponse> => {
        return this.get<ClientSummaryListResponse>(ClientEndpoints.CLIENTS_SUMMARY, cts, {
            params,
        });
    };

    listClient = async (
        params: {
            search?: string;
            order?: ClientListOrder;
            showOnlyActive?: boolean;
        },
        cts: XHRRequestCanceler
    ) => {
        return this.get<ClientListResponse>(ClientEndpoints.CLIENTS, cts, {
            params,
        });
    };

    getClient = async (cts: XHRRequestCanceler, clientId: string) => {
        return this.get<ClientDetailsApiDataResponse>(ClientEndpoints.CLIENT(clientId), cts);
    };

    updateClient = async (clientId: string, client: Client, cts: XHRRequestCanceler) => {
        const body = {
            ...client,
        };
        return this.patch(ClientEndpoints.UPDATE_CLIENT(clientId), body, cts);
    };

    createClient = async (client: Client, cts: XHRRequestCanceler) => {
        const body = {
            ...client,
        };
        return this.post<ApiDataResponse<string>>(ClientEndpoints.CREATE_CLIENT, body, cts);
    };
}

const ClientDataServiceName = 'ClientDataService';
export { ClientDataService, ClientDataServiceName };
